import React, { useEffect, useState } from "react";
import Stepper from "../../ui/Stepper";
import { STEPPER_LIST_COUNTRY } from "../../../../constants/cms";
import { useNavigate, useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import ContentDetailForm from "./contentDetailForm";
import {
  getCountryContentDetail,
  clearCountryContentDetail,
  putCountryContentDetail,
} from "../../../../../store/slices/country";
const ContentDetail = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [saveAndNext, setSaveAndNext] = useState(false);
  const user = useSelector((state) => state?.userData?.user?.data);
  const userPermission = useSelector(
    (state) => state.userData?.userPermission?.data
  );
  const dispatch = useDispatch();
  const { countryContentDetailData, putCountryContentDetailData } = useSelector(
    (state) => state.cmsCountry
  );
  const [initialValues, setInitialValues] = useState({});

  useEffect(() => {
    if (id) {
      dispatch(getCountryContentDetail({ country_id: id }));
    }
    return () => {
      dispatch(clearCountryContentDetail());
    };
  }, [id]);

  useEffect(() => {
    if (putCountryContentDetailData) {
      if (saveAndNext) {
        navigate(
          `/cms/country/${putCountryContentDetailData?.country_id}/gallery`
        );
      }else{
        dispatch(getCountryContentDetail({ country_id: id }));
      }
      setSaveAndNext(false);
    }
  }, [putCountryContentDetailData]);
  useEffect(() => {
    if (countryContentDetailData) {
      let newvalues = {
        country_name: countryContentDetailData.country_content_detail
          ?.country_name
          ? countryContentDetailData.country_content_detail?.country_name
          : null,
        country_guide: countryContentDetailData.country_content_detail
          ?.country_guide
          ? countryContentDetailData.country_content_detail?.country_guide
          : null,
        college_guide: countryContentDetailData.country_content_detail
          ?.college_guide
          ? countryContentDetailData.country_content_detail?.college_guide
          : null,
        course_guide: countryContentDetailData.country_content_detail
          ?.course_guide
          ? countryContentDetailData.country_content_detail?.course_guide
          : null,
        country_link: countryContentDetailData.country_content_detail
          ?.country_link
          ? countryContentDetailData.country_content_detail?.country_link
          : "",
        college_link: countryContentDetailData.country_content_detail
          ?.college_link
          ? countryContentDetailData.country_content_detail?.college_link
          : "",
        course_link: countryContentDetailData.country_content_detail
          ?.course_link
          ? countryContentDetailData.country_content_detail?.course_link
          : "",
        about_the_country:
          countryContentDetailData.country_content_detail?.about_the_country ??
          "",
        lor: countryContentDetailData.country_content_detail?.lor ?? "",
        sop: countryContentDetailData.country_content_detail?.sop ?? "",
        work_permit:
          countryContentDetailData.country_content_detail?.work_permit ?? "",
        why_study:
          countryContentDetailData.country_content_detail?.why_study ?? "",
        scholarship:
          countryContentDetailData.country_content_detail?.scholarship ?? "",
        student_visa:
          countryContentDetailData.country_content_detail?.student_visa ?? "",
        application:
          countryContentDetailData.country_content_detail?.application ?? "",
        min_wage: countryContentDetailData.country_content_detail?.min_wage
          ? countryContentDetailData.country_content_detail?.min_wage
          : "",
        max_hours: countryContentDetailData.country_content_detail?.max_hours
          ? countryContentDetailData.country_content_detail?.max_hours
          : "",
        document:
          countryContentDetailData.country_content_detail?.document ?? "",
        part_time_work:
          countryContentDetailData.country_content_detail?.part_time_work ?? "",
        updated_by: countryContentDetailData.country_content_detail?.updated_by,
        last_updated:
          countryContentDetailData.country_content_detail?.last_updated,
      };
      setInitialValues(newvalues);
    }
  }, [countryContentDetailData]);

  const submit = (values) => {
    let data = new FormData();
    if (
      values.country_guide != null &&
      typeof values.country_guide != "string"
    ) {
      data.append("country_guide", values.country_guide);
    }
    if(values.country_guide ===null){
      data.append("country_guide", "");
    }
    if (
      values.college_guide != null &&
      typeof values.college_guide != "string"
    ) {
      data.append("college_guide", values.college_guide);
    }
    if(values.college_guide ===null){
      data.append("college_guide", "");
    }
    if (
      values.course_guide != null &&
      typeof values.course_guide != "string"
    ) {
      data.append("course_guide", values.course_guide);
    }
    if(values.course_guide ===null){
      data.append("course_guide", "");
    }
    data.append("country_link", values.country_link);
    data.append("college_link", values.college_link);
    data.append("course_link", values.course_link);
    data.append("about_the_country", values.about_the_country);
    data.append("why_study", values.why_study);
    data.append("scholarship", values?.scholarship);
    data.append("student_visa", values?.student_visa);
    data.append("lor", values?.lor);
    data.append("sop", values?.sop);
    data.append("application", values?.application);
    data.append("document", values?.document);
    data.append("min_wage", values?.min_wage);
    data.append("max_hours", values?.max_hours);
    data.append("part_time_work", values?.part_time_work);
    data.append("work_permit", values?.work_permit);
    data.append("user_id", user?.id);
    dispatch(putCountryContentDetail({ country_id: id }, data));
  };

  return (
    <div>
      <div className={"mt50"}>
        <div className={`${"stepper"} ${"examviewlist"}`}>
          <Stepper data={STEPPER_LIST_COUNTRY} activeStep={2} />
        </div>
      </div>
      <div>
        {id && (
          <ContentDetailForm
            submit={(e) => submit(e)}
            initialValues={initialValues}
            setSaveAndNext={setSaveAndNext}
            userPermission={userPermission}
          />
        )}
      </div>
    </div>
  );
};

export default ContentDetail;
